module.exports = __webpack_public_path__ + "static/media/header-bg.7031f166.jpg";